// `blocked` arrives with the orchestrator's own migration. No LABELS here —
// the status → badge map belongs to the board screen.
export const ANALYSIS_STATUS_VALUES = {
  pending: 'pending',
  running: 'running',
  done: 'done',
  failed: 'failed',
  invalidated: 'invalidated',
} as const;

export type AnalysisStatus =
  (typeof ANALYSIS_STATUS_VALUES)[keyof typeof ANALYSIS_STATUS_VALUES];
